<template>
  <div class="ability-detail">
    <div class="card-title mb-3" style="font-size: 16px" :class="{ 'show-bg': showTitleBg }">图谱详情</div>
    <el-form label-position="left" label-width="60px" style="margin-left: 24px;">
      <el-form-item
        v-for="(target, index) in form.list"
        :label="'L' + (index + 1)"
        :key="index"
        class="border-bottom"
      >
        <div class="card-title">{{ target.indicator_name }}</div>
        <div class="ability-desc mb-2">
          {{ target.description }}
        </div>
        <template v-if="showContent">
          <el-form-item label="评价指标">
            {{ target.level_name }}
          </el-form-item>
          <el-form-item label="指标评语">
            <div class="flex comment-wrapper mb-2" v-for="(comment, _index) in target.content" :key="_index">
              <div class="flex-left" style="min-width: 92px">
                {{ comment.tier }}、{{ comment.max }}~{{ comment.min
                }}<template v-if="comment.alias">({{ comment.alias }})</template>：
              </div>
              <div class="flex-right">
                {{ comment.evaluation }}
              </div>
            </div>
          </el-form-item>
        </template>
        <el-form-item label="关联主题与活动" class="mb-2" v-if="showTitleBg">
          <div class="">满分：100</div>
          <div class="" v-for="(topic, index) in target.section" :key="index">
            <strong style="text-decoration: underline;">{{ topic.weight }}%{{ topic.name }}</strong>，其中<span>{{
              topic.activity.map((_) => _.weight + '%' + _.name).join('，')
            }}</span
            >
          </div>
        </el-form-item>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => {
        return {
          targetList: [],
        }
      },
    },
    showTitleBg: {
      type: Boolean,
      default: false,
    },
    showContent: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      letters: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    }
  },
  methods: {
    handleBack() {
      this.$router.go(-1)
    },
  },
}
</script>
<style lang="scss" scoped>
.ability-detail {
  .card-title {
    color: #343a40;
    font-weight: bold;
    &.show-bg {
      height: 48px;
      line-height: 48px;
      background-color: #f3f6f9;
      padding: 0 24px;
    }
  }
  ::v-deep {
    .el-form {
      .el-form-item__content {
        .el-form-item {
          &__label {
            width: 120px !important;
            line-height: 1.8 !important;
            text-align: right;
            padding-right: 16px;
          }
          &__content {
            line-height: 1.8 !important;
            margin-left: 120px !important;
          }
        }
      }
      .ability-desc {
        line-height: 1.8;
        font-weight: bold;
      }
    }
  }
}
</style>
